import { createContext, type PropsWithChildren, useContext, useEffect, useState } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { SurveysStore } from 'pages/surveys/store/surveysStore'
import { useSurveysPageContext } from 'pages/surveys/context/surveysPageContext'

export const SurveysContext = createContext<SurveysStore | null>(null)

export const useSurveysContext = () => {
  const context = useContext(SurveysContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with SurveysContext')

  return context
}

export const SurveysProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const { pageLayoutStore } = useSurveysPageContext()
  const [store] = useState(() => new SurveysStore(entities, pageLayoutStore))

  useEffect(() => {
    void store.init()
    return () => store.dispose()
  }, [])

  return <SurveysContext.Provider value={store}>{children}</SurveysContext.Provider>
}
